import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["aria-busy"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "error",
  role: "alert"
}
const _hoisted_4 = { role: "status" }
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "error",
  role: "alert"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

import { computed, onBeforeUnmount, ref, watch } from "vue";
import StudioSelectField from "./StudioSelectField.vue";
import { readWorkspaceGilCalibration, workspaceGilCalibrationFiles, type WorkspaceGilCalibration } from "./workspaceGilCalibration";
import { WORKSPACE_STRUCT_ID_FIELDS } from "./workspaceStructIds";
import { cloneWorkspaceTarget, workspaceTargetKey, type WorkspaceTarget } from "./workspaceSettings";


export default /*@__PURE__*/_defineComponent({
  __name: 'WorkspaceGilCalibration',
  props: {
    target: {},
    disabled: { type: Boolean },
    overlayTarget: {}
  },
  emits: ["change", "busy"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const fileInput = ref<HTMLInputElement>();
const calibration = ref<WorkspaceGilCalibration>();
const busy = ref(false), error = ref("");
let request = 0;
watch(calibration, value => emit("change", value), { deep: true, flush: "sync" });
watch(() => workspaceTargetKey(props.target), () => {
  request++; calibration.value = undefined; error.value = ""; busy.value = false; emit("busy", false);
});
onBeforeUnmount(() => { request++; emit("busy", false); emit("change", undefined); });
const pending = computed(() => {
  if (!calibration.value) return "";
  try { workspaceGilCalibrationFiles(calibration.value); return ""; }
  catch (reason) { return reason instanceof Error ? reason.message : String(reason); }
});
const structLabel = (key: string) => {
  const field = WORKSPACE_STRUCT_ID_FIELDS.find(field => field.key === key);
  return field ? `${field.group} · ${field.label}` : key;
};
const skillLabel = (id: string) => calibration.value?.result.skills.presets.find(preset => preset.id === id)?.name || id;
async function readFile(event: Event) {
  const input = event.target as HTMLInputElement, file = input.files?.[0];
  input.value = "";
  if (!file || busy.value || props.disabled) return;
  const version = ++request, target = cloneWorkspaceTarget(props.target);
  calibration.value = undefined; error.value = ""; busy.value = true; emit("busy", true);
  try {
    const result = await readWorkspaceGilCalibration(file, target);
    if (version === request) calibration.value = result;
  } catch (reason) {
    if (version === request) error.value = reason instanceof Error ? reason.message : String(reason);
  } finally {
    if (version === request) { busy.value = false; emit("busy", false); }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "gil-calibration",
    "aria-label": "导入 GIL 校对编辑器参数",
    "aria-busy": busy.value
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("strong", null, "导入 GIL 校对编辑器参数", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("p", null, "选择元件版时，需要导入 GIL 存档校对编辑器参数，完成后才能创建工作区。此步骤仅在本机读取，不会将存档上传云端。", -1)),
    _createElementVNode("button", {
      type: "button",
      disabled: busy.value || __props.disabled,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (fileInput.value?.click()))
    }, _toDisplayString(busy.value ? '正在校对…' : calibration.value ? '重新导入 GIL' : '导入 GIL 存档'), 9, _hoisted_2),
    _createElementVNode("input", {
      ref_key: "fileInput",
      ref: fileInput,
      type: "file",
      accept: ".gil",
      hidden: "",
      "aria-label": "选择校对用 GIL 存档",
      onChange: readFile
    }, null, 544),
    (error.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true),
    (calibration.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("p", _hoisted_4, "「" + _toDisplayString(calibration.value.fileName) + "」已识别 " + _toDisplayString(calibration.value.result.structs.matched.length) + " 项结构体和 " + _toDisplayString(calibration.value.result.skills.matched.length) + " 项技能动画。" + _toDisplayString(pending.value ? '请选择以下候选，完成校对。' : '校对完成，参数将在创建时保存到新工作区。'), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calibration.value.result.structs.ambiguous, (key) => {
            return (_openBlock(), _createElementBlock("label", { key: key }, [
              _createTextVNode(_toDisplayString(structLabel(key)) + " ", 1),
              _createVNode(StudioSelectField, {
                modelValue: calibration.value.structSelections[key],
                "onUpdate:modelValue": ($event: any) => ((calibration.value.structSelections[key]) = $event),
                to: __props.overlayTarget ?? false,
                disabled: __props.disabled,
                "aria-label": `${structLabel(key)} 校对候选 ID`,
                placeholder: "请选择结构体 ID"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calibration.value.result.structs.candidates[key], (candidate) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: candidate.id,
                      value: candidate.id
                    }, _toDisplayString(candidate.id) + " · " + _toDisplayString(candidate.source), 9, _hoisted_5))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "to", "disabled", "aria-label"])
            ]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calibration.value.result.skills.ambiguous, (id) => {
            return (_openBlock(), _createElementBlock("label", { key: id }, [
              _createTextVNode(_toDisplayString(skillLabel(id)) + " ", 1),
              _createVNode(StudioSelectField, {
                modelValue: calibration.value.skillSelections[id],
                "onUpdate:modelValue": ($event: any) => ((calibration.value.skillSelections[id]) = $event),
                to: __props.overlayTarget ?? false,
                disabled: __props.disabled,
                "aria-label": `${skillLabel(id)} 校对候选 ID`,
                placeholder: "请选择技能动画 ID"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calibration.value.result.skills.candidates[id], (candidate) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: candidate.id,
                      value: candidate.id
                    }, _toDisplayString(candidate.id) + " · " + _toDisplayString(candidate.name), 9, _hoisted_6))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "to", "disabled", "aria-label"])
            ]))
          }), 128)),
          (pending.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(pending.value), 1))
            : _createCommentVNode("", true),
          (calibration.value.result.structs.missing.length || calibration.value.result.skills.missing.length)
            ? (_openBlock(), _createElementBlock("details", _hoisted_8, [
                _createElementVNode("summary", null, "未识别项保留默认值（" + _toDisplayString(calibration.value.result.structs.missing.length + calibration.value.result.skills.missing.length) + " 项）", 1),
                (calibration.value.result.structs.missing.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, "结构体：" + _toDisplayString(calibration.value.result.structs.missing.map(structLabel).join('、')), 1))
                  : _createCommentVNode("", true),
                (calibration.value.result.skills.missing.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, "技能动画：" + _toDisplayString(calibration.value.result.skills.missing.map(skillLabel).join('、')), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})